export default __webpack_public_path__ + "static/media/cityColoringSample.b86de20335d3fd19c23f1f68260b8fad.png";